import useTranslateParse from 'util/useTranslateParse'

const Subtitle = () => {
  const translateParse = useTranslateParse()
  return (
    <div>
      {translateParse(
        'Create custom commissions that can be assigned to team members. To learn more about how to use this feature, <a>click here<a>.',
        {
          a: (label) => (
            <a
              href={'https://support.opensolar.com/hc/en-us/articles/13067878185359-How-to-add-commission'}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none', whiteSpace: 'nowrap', color: 'rgb(24, 144, 255)' }}
            >
              {label}
            </a>
          ),
        }
      )}
    </div>
  )
}

export default {
  list: { lazy: () => import('./Commissions'), component: 'CommissionsList' },
  edit: { lazy: () => import('./Commissions'), component: 'CommissionsEdit' },
  create: { lazy: () => import('./Commissions'), component: 'CommissionsCreate' },
  options: {
    create: {
      subtitle: <Subtitle />,
    },
    list: {
      subtitle: null,
    },
    edit: {
      subtitle: null,
    },
  },
}
